module.exports = "/_next/static/images/header-logo-shenxiu-c5ee7e8d9ef28dd49a21199279e38582.png";